import { PessoaDTO } from "./pessoa.dto";

export class PessoaFisicaJuridicaDTO {

    pessoaDTO: PessoaDTO;
    cdPessoa: number;

    constructor(
        pessoaDTO?: PessoaDTO,
        cdPessoa?: number,
    ) {
        this.pessoaDTO = pessoaDTO;
        this.cdPessoa = cdPessoa;
    }
}